export default __webpack_public_path__ + "static/media/tag-icon.84687f7f.svg";